module.exports = __webpack_public_path__ + "img/WeChat.1d0b4e76.png";